import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getAccountCustomerRefunds,
  getAccountCustomerRefund,
  createAccountCustomerRefund,
  updateAccountCustomerRefund,
  deleteAccountCustomerRefund,
} from "api/accountCustomerRefundApi"

export const ACCOUNT_CUSTOMER_REFUND_QUERY_KEY = "account-customer-refunds"

export const useAccountCustomerRefunds = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_CUSTOMER_REFUND_QUERY_KEY,
    getAccountCustomerRefunds,
    params,
    enabled
  )
}

export const useAccountCustomerRefund = (id, enabled = true) => {
  return useResourceItem(
    ACCOUNT_CUSTOMER_REFUND_QUERY_KEY,
    getAccountCustomerRefund,
    id,
    enabled
  )
}

export const useCreateAccountCustomerRefund = () => {
  return useCreateResource(
    createAccountCustomerRefund,
    ACCOUNT_CUSTOMER_REFUND_QUERY_KEY
  )
}

export const useEditAccountCustomerRefund = () => {
  return useEditResource(
    updateAccountCustomerRefund,
    ACCOUNT_CUSTOMER_REFUND_QUERY_KEY
  )
}

export const useDeleteAccountCustomerRefund = () => {
  return useDeleteResource(
    deleteAccountCustomerRefund,
    ACCOUNT_CUSTOMER_REFUND_QUERY_KEY
  )
}
